import { useSelector } from "react-redux";
import { Button, Container, Message } from "semantic-ui-react";
import { useState } from "react";
import { FamilyMembersModal } from '../../components/modal/FamilyMembersModal';
import { AssetsModal } from '../../components/modal/AssetsModal';
import ReAssignReviewers from "../../components/manualInputs/ReAssignReviewers";
import ButtonChangeStatus from "../../components/manualInputs/ButtonChangeStatus";
import ViewDocumentModal from "../../components/manualInputs/DocumentCategorization/ViewDocumentModal";
import { generateToken, validateEstatePreview } from "../../actions/estate-manual-input.actions";
import enviroment from "../../enviroment";

export const HeaderOptions = ({
    estateManualInputRequest,
    allowSend,
    clientId,
    assetIndex,
    saveForLaterBtn_Click,
    finishReviewBtn_Click,
    loaderSaveForLater,
    loaderFinishReview
}) => {
    const me = useSelector(state => state.me);
    const [loaderPreview, setLoaderPreview] = useState(false)
    const [showFamilyModal, setShowFamilyModal] = useState(false);
    const [showEntitiesModal, setShowEntitiesModal] = useState(false);
    const [showAssetsModal, setShowAssetsModal] = useState(false);

    const openPreview = async () => {
        setLoaderPreview(true)
        try {
            const isValid = await validateEstatePreview({
                clientId,
                reviewer: estateManualInputRequest.reviewer,
                advisor: estateManualInputRequest.advisor,
                index: assetIndex
            })
            if(!isValid){
                // eslint-disable-next-line
                throw {message: "There is an error in the snapshot, and it cannot be generated.\nPlease notify the development team."}
            }
            const data = await generateToken({
                clientId,
                reviewer: estateManualInputRequest.reviewer,
                advisor: estateManualInputRequest.advisor,
                index: assetIndex
            })
            window.open(`${enviroment.fpalphaUrl}/external-snapshot-preview?token=${data}&area=estate`,'_blank')
        } catch (error) {
            console.log({error})
        }
        setLoaderPreview(false)
    }

    return (<div>
        {((estateManualInputRequest?.status === 'In review' && estateManualInputRequest?.reviewer?._id === me?._id) || estateManualInputRequest?.status === 'Peer review') &&
            <div style={{textAlign: 'right', marginBottom: '1rem'}}>
                <Button color='grey' onClick={saveForLaterBtn_Click} loading={loaderSaveForLater} disabled={loaderSaveForLater}>Save for later</Button>
                <Button style={{ paddingLeft: '50px', paddingRight: '50px' }} disabled={!allowSend || loaderFinishReview} color='green' onClick={finishReviewBtn_Click} loading={loaderFinishReview}>Finish review</Button>
            </div>
        }
        <div style={{display:"flex", padding: "5px 0px", justifyContent:"flex-end"}}>
            <div>
                <ButtonChangeStatus area={"estate"} clientId={clientId} assetIndex={assetIndex} />
            </div>
            <div>
                <ReAssignReviewers area={"estate"} clientId={clientId} assetIndex={assetIndex} />
            </div>
        </div>
        <div style={{textAlign: 'right', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-end', rowGap: '0.5rem'}}>
            <Button color='red' onClick={() => openPreview()} loading={loaderPreview} disabled={loaderPreview}>
                Preview
            </Button>
            <Button color='orange' onClick={() => setShowFamilyModal(true)}>
                Add Persons
            </Button>
            <Button color='purple' onClick={() => setShowEntitiesModal(true)}>
                Add Entities
            </Button>
            <Button color='green' onClick={() => setShowAssetsModal(true)}>
                Assets
            </Button>
            {/* estateManualInputRequest?.status === 'In review' && estateManualInputRequest.reviewer._id === me._id &&
                <Button color='grey' onClick={cloneSpouseDataBtn_Click}>
                    Clone data from spouse
                </Button>
             */}
            {(estateManualInputRequest?.status !== 'Ready' || (estateManualInputRequest?.status === 'Ready' && me.permissions.includes('manual_inputs:open_documents'))) &&
                <Button color='blue' onClick={() => window.open(`/dashboard/estate-manual-input/${clientId}/${assetIndex}/files`)}>
                    Open documents for {estateManualInputRequest?.client?.displayName || "..."}
                </Button>
            }
            <>
                <ViewDocumentModal area={"estate"} clientId={clientId} assetIndex={assetIndex} estateManualInputRequest={estateManualInputRequest} />
            </>
        </div>
        <FamilyMembersModal open={showFamilyModal} closeBtn_Click={() => setShowFamilyModal(false)} editingEnabled={estateManualInputRequest?.status === 'In review' || estateManualInputRequest?.status === 'Peer review'} />
        <FamilyMembersModal type={'trusts'} open={showEntitiesModal} closeBtn_Click={() => setShowEntitiesModal(false)} editingEnabled={['In review', 'Peer review'].includes(estateManualInputRequest?.status)} />
        <AssetsModal open={showAssetsModal} closeBtn_Click={() => setShowAssetsModal(false)} editingEnabled={estateManualInputRequest?.status === 'In review' || estateManualInputRequest?.status === 'Peer review'} />
    </div>)
}

export const FooterOptions = ({estateManualInputRequest, allowSend, saveForLaterBtn_Click, finishReviewBtn_Click, loaderSaveForLater, loaderFinishReview}) => {
    const me = useSelector(state => state.me);

    return <>
        {((estateManualInputRequest?.status === 'In review' && estateManualInputRequest?.reviewer?._id === me?._id) || estateManualInputRequest?.status === 'Peer review') &&
            <Container fluid textAlign='right' style={{ marginTop: '20px' }}>
                <Button color='grey' onClick={() => saveForLaterBtn_Click()} loading={loaderSaveForLater} disabled={loaderSaveForLater}>Save for later</Button>
                <Button style={{ paddingLeft: '50px', paddingRight: '50px' }} disabled={!allowSend || loaderFinishReview} color='green' onClick={() => finishReviewBtn_Click()} loading={loaderFinishReview} >Finish review</Button>
            </Container>
        }
        {estateManualInputRequest?.status === 'Ready' &&
            <Message color='green'>This manual input has already been marked as REVIEWED.</Message>
        }
    </>
}